import React from "react";
import { TextField, Box } from "@mui/material";
import CustomSelect from "../CustomSelect/CustomSelect";
import MultiSelect from "../CustomSelect/MultiSelect";

const DynamicField = ({ value, onChange, ...field }) => {


  const renderField = () => {
    const { style, label, type, options, placeholder } = field;

    switch (type) {
      case "SingleSelectOption":
        return (
          <CustomSelect
            value={value}
            onChange={(value) => onChange(value)}
            options={options}
            placeholder={placeholder || "Select"}
            style={style}
          />
        );
      case "MultiSelectOption":
        return (
          <MultiSelect
            value={value}
            onChange={(value) => onChange(value)}
            options={options}
            placeholder={placeholder || "Select Options"}
            style={style}
          />
        );
      case "Number":
        return (
          <TextField
            type="number"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            label={label}
            fullWidth
            placeholder={placeholder}
            style={style}
          />
        );
      case "String":
        return (
          <TextField
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            label={label}
            fullWidth
            placeholder={placeholder}
            style={style}
          />
        );
      default:
        return <TextField
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          label={label}
          fullWidth
          placeholder={placeholder}
          style={style}
        />;
    }
  };

  return (
    <Box>{renderField()}</Box>
  );
};

export default DynamicField;
